<template>
	<div class="container">
		<Header ref="headerBar" @onSearch="searchBtn"></Header>
		<div class="search-conWrap">
			<div class="breadcrumbs wrap">
				<img src="../../assets/images/icon-home.png" alt="" class="breadcrumbs-icon" />
				<a href="/">首页</a> > 免费声明
			</div>
			<div class="i-main wrap clearfix border-10">
				<div class="title-box">
					<span>免费声明</span>
				</div>
				<div class="content-box mt-40" v-html="content"></div>
			</div><!-- i-main end  -->

		</div><!-- search-conWrap end -->

		<div class="i-m9-wrap mt-60">
			<div class="i-m9 wrap clearfix">
				<div class="i-m9-item">
					<img src="../../assets/images/i-m9-icon_03.png" alt="" class="i-m9-icon" />
					<div class="i-m9-info">
						<h4>全球品牌总数</h4>
						<p>300000<em>+</em></p>
					</div>
				</div>
				<div class="i-m9-item">
					<img src="../../assets/images/i-m9-icon_06.png" alt="" class="i-m9-icon" />
					<div class="i-m9-info">
						<h4>城市精选商家</h4>
						<p>100000<em>+</em></p>
					</div>
				</div>
				<div class="i-m9-item">
					<img src="../../assets/images/i-m9-icon_09.png" alt="" class="i-m9-icon" />
					<div class="i-m9-info">
						<h4>行业品牌榜单</h4>
						<p>5000<em>+</em></p>
					</div>
				</div>
			</div>
		</div><!-- i-m9-wrap end -->

		<Footer></Footer>

		<el-backtop style="width:50px;height:50px;">
			<div style="{
          height: 100%;
          width: 100%;
          background: #da0505 ;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          z-index: 9999;
        }">
				<img src="../../assets/images/backtop.png" alt="" style="vertical-align: top;">
			</div>
		</el-backtop>


	</div>
</template>

<script>
	
	import Footer from "@/components/footer";
	import Header from "@/components/header";
	export default {
		name: "statement",
		components: {
			Header,
			Footer
		},
		data() {
			return {
				content:'<p>欢迎访问品牌之家（zgall.com）。在使用本网站提供的服务和信息前，请您仔细阅读以下免责声明。使用本网站即表示您已阅读、理解并同意遵守以下条款。</p><p><br></p><h4 data-sider-select-id="92c247b9-f915-48e9-ba59-6ecc1fc6d307">一、<strong>信息准确性</strong></h4><p><br></p><p>品牌之家致力于提供准确、最新的品牌排行榜、生活文章推荐和网店推荐信息。尽管我们尽一切努力确保内容的准确性和完整性，但由于信息来源广泛且动态变化，品牌之家无法保证所有信息的绝对准确性、及时性和完整性。</p><p><br></p><p><br></p><h4 data-sider-select-id="17431946-c360-482d-87cc-bb3a1b6c34b0">二、<strong>内容来源</strong></h4><p><br></p><p>品牌之家所提供的排行榜、文章推荐和网店信息来源于公开渠道、用户反馈及其他第三方资源。我们会对这些信息进行审核和整理，但不对信息的真实性、合法性和准确性做出任何明示或暗示的保证。</p><p><br></p><p><br></p><h4 data-sider-select-id="b76ccb97-4b94-4d96-bd74-e9fd26bc8687">三、<strong>第三方链接</strong></h4><p><br></p><p>品牌之家可能包含指向第三方网站或服务的链接。这些链接仅为方便用户提供，并不表示品牌之家对这些网站或服务的推荐、认可或保证。用户在访问这些第三方网站时，应自行承担风险，并遵守第三方网站的使用条款和隐私政策。</p><p><br></p><p><br></p><h4 data-sider-select-id="52443365-43a3-4336-95a0-9194bd3a244c">四、<strong>用户评论与反馈</strong></h4><p><br></p><p>品牌之家欢迎用户对网站内容提供评论和反馈，但不对用户所发布的内容承担任何责任。用户评论仅代表个人观点，并不反映品牌之家的立场或观点。我们保留删除不当评论或反馈的权利。</p><p><br></p><p><br></p><h4 data-sider-select-id="bac175a0-d8b4-4f25-8118-3381729b0d72">五、<strong>使用风险</strong></h4><p><br></p><p>用户在使用品牌之家提供的任何信息和服务时，应自行判断和承担风险。品牌之家对因使用或无法使用本网站内容所产生的任何直接、间接、偶然、特殊及后续的损害不承担任何责任，包括但不限于经济损失、数据丢失或其他商业损失。</p><p><br></p><p><br></p><h4 data-sider-select-id="0dc67935-e7f6-42a4-a3b6-7e4028ddc3c8">六、<strong>知识产权</strong></h4><p><br></p><p>品牌之家所有内容，包括但不限于文字、图像、标志、图表、音频、视频等，均受版权、商标和其他相关法律的保护。未经品牌之家书面授权，禁止任何形式的复制、传播或使用。</p><p><br></p><p><br></p><h4 data-sider-select-id="7bb7f20e-f536-41ab-982f-36a13db7da54">七、<strong>法律适用</strong></h4><p><br></p><p>本免责声明的解释和适用以及因使用本网站所发生的争议，均适用中华人民共和国法律。因使用本网站产生的任何争议，应提交品牌之家所在地有管辖权的法院解决。</p><p><br></p><p><br></p><h4 data-sider-select-id="034fba38-8254-45d5-80a9-2925da14d729">八、<strong>免责条款更新</strong></h4><p><br></p><p>品牌之家保留随时更新本免责声明的权利。任何修改将在本页面发布，并即时生效。请定期查阅以了解最新条款。</p><p>感谢您对品牌之家的支持与理解。如有任何疑问或需要进一步的信息，请通过我们的客服邮箱与我们联系。</p>'
			};
		},

		created() {},
		beforeUpdate() {},
		computed: {},
		mounted() {},
		methods: {
			
		},
	}
</script>

<style scoped>
	.i-main{
		padding: 25px 40px 60px 40px;
		box-sizing: border-box;
		border: 1px solid #ececec;
	}
	.title-box{
		height: 49px;
		border-bottom: 1px solid #eef3f5;
	}
	
	.title-box span{
		height: 47px;
		border-bottom: 2px solid #da0505;
		display: inline-block;
		position: relative;
		z-index: 3;
		bottom: -1px;
		font-size: 20px;
		color: #000;
		line-height: 30px;
	}
	
	.content-box{
		line-height: 30px;
	}
	
</style>